const styles = {
  container: {
    display: 'flex',
    flexDirection: 'column',
    gap: '24px',
    paddingBottom: '32px',
  },
  header: {
    '@media (max-width: 1024px)': {
      flexDirection: 'column',
      alignItems: 'start',
    },
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '0 32px',
  },
  content: {
    width: '100%',
    display: "flex",
    justifyContent: "center",
    alignItems: "flex-start",
    backgroundColor: "#FFF",
    borderRadius: "16px",
  },

  tabs: {
    fontSize: '14px',
    fontWeight: 500,
    textTransform: 'none',
    display: 'flex',
    gap: '32px',
    padding: "0",
    ' & .MuiTabs-flexContainer': {
      gap: '32px',
      '& .MuiTabs-indicator': {
        width: '16px !important',
      }
    },
    '& .MuiTouchRipple-root': {
      padding: 0,
      textAlign: 'center !important',
    },
    '& .MuiTabs-indicator': {
      display: 'none'
    },
    '& .MuiTabs-indicatorSpan': {
      backgroundColor: '#FF8800',
      color: "#FF8800",
      width: '16px',
    },
    '& .Mui-selected': {
      color: "#FF8800",
      minWidth: 'max-content',
    },
    '& .Mui-selected::after': {
      content: "''",
      position: "absolute",
      bottom: 0,
      left: "50%",
      transform: "translateX(-50%)",
      width: "16px",
      height: "4px",
      backgroundColor: "#FF8800",
      borderRadius: "10px !important"
    },
    '& .MuiTab-root': {
      minWidth: 'max-content',
    }
  },

  tab: {
    padding: 0,
    textTransform: 'none',
    '& .Mui-selected': {
      color: "#FF8800"
    },
  },
  accordion: {
    border: 'none',
    '&.Mui-expanded:last-of-type': {
      borderRadius: '32px'
    }
  },
  accordion_summary: {
    padding: '0 32px',
    '& .MuiAccordionSummary-content': {
      margin: "32px 0"
    }
  },
  subtitle: {
    fontSize: '14px',
    fontWeight: '400',
    color: "#5F5F5F"
  },
  title: {
    fontSize: '16px',
    fontWeight: '500'
  },
  flex_center_box: {
    display: 'flex',
    gap: '16px',
    alignItems: 'center',
  }
} as const

export default styles